module.exports = __webpack_public_path__ + "media/TRX_City_Welcome_Prudential_TRX.e3840ccb.mp4";